/**
 * @ Author: fangjy
 * @ Create Time: 2020-11-09 10:59:52
 * @ Modified by: fangjy
 * @ Modified time: 2020-11-24 10:08:28
 * @ Description:签约月嫂-月嫂个人主页
 *              点击预定月嫂
                点击立即咨询
                弹窗-点击确认
 */

import { newTrackClick, newTrackView } from '@/utils/newTrack'

export const PAGE_LEVEL_ID = '121012508'

export const ENTER_YS_DETAIL = {
  event_name: '点击预定月嫂',
  event_code: 200001
}

export const TOGGLE_CITY = {
  event_name: '点击立即咨询',
  event_code: 200002
}
export const TOGGLE_DISTI = {
  event_name: '弹窗-点击确认',
  event_code: 200004
}

export const trackView = () => {
  newTrackView(PAGE_LEVEL_ID)
}

const config = {
  TOGGLE_DISTI: {
    event_name: '弹窗-点击确认',
    event_code: 200004
  },
  TOGGLE_CITY: {
    event_name: '点击立即咨询',
    event_code: 200002
  },
  ENTER_YS_DETAIL: {
    event_name: '点击预定月嫂',
    event_code: 200001
  }
}

export const trackClick = targetElement => {
  console.log('dasdssad', config[targetElement].event_code)
  newTrackClick(
    PAGE_LEVEL_ID,
    config[targetElement] ? config[targetElement].event_code : '',
    config[targetElement] ? config[targetElement].event_name : ''
  )
}
